<template>
  <v-flex xs12>
    <v-card raised>
      <v-container>
        <v-layout>
          <v-flex>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ this.information.category }}</div>
                <div>{{ this.information.info }}</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>

<script>
  export default {
    props: ["information"],
    data() {
      return {};
    }
  }

</script>

<style>

</style>
